/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  firebase : {
    apiKey: "AIzaSyDIv0cRts3SVIzToW2wteBIiT_o71UOyqg",
    authDomain: "displaygigcro.firebaseapp.com",
    projectId: "displaygigcro",
    storageBucket: "displaygigcro.appspot.com",
    messagingSenderId: "997184519613",
    appId: "1:997184519613:web:8b671e5d4937b01fb826d4",
    measurementId: "G-S0WG0FLDT8"
  }
};